import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import CheckboxField from '@grnhse/seedling/lib/birch/components/forms/fields/checkbox_field';
import PopoverButton from 'talent_matching/components/filters/popover_button';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.filter_row.previously_rejected');

export const PreviouslyRejectedContent = () => {
  return (
    <Stack spacing={2} direction="column">
      <CheckboxField
        name="excludePreviouslyRejected"
        label={t('checkbox_label')}
        value="excludePreviouslyRejected"
      />
    </Stack>
  );
};

const PreviouslyRejected = () => {
  const { watch } = useFormContext();
  const excludePreviouslyRejected = watch('excludePreviouslyRejected');

  const buttonLabel = `${t('title')}${excludePreviouslyRejected ? ' (1)' : ''}`;

  return (
    <PopoverButton buttonLabel={buttonLabel} title={t('title')}>
      <PreviouslyRejectedContent />
    </PopoverButton>
  );
};

export default PreviouslyRejected;
